import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import { strictFetcher } from './strict-fetcher'

/// One pool's share of an asset's liquidity, for the hover breakdown.
interface AssetStatsPool {
	pool_id: string
	name: string | null
	reserve_token: string
	reserve_other: string
	other_id: string
	other_name: string | null
	tvl_usd: number | null
}

/// `GET /alkane/asset/:id/stats` — the header rail's deep stats: market cap
/// (op-101 supply × price), holders (alkanode) with a 24h delta from stored
/// snapshots, 1w change (USD index), and buy/sell splits of 24h volume and
/// transactions (espo activity). Every field is null when its source can't
/// answer — the rail renders "—", never a fabricated zero.
export interface AssetStats {
	id: string
	supply: string | null
	market_cap_usd: number | null
	holders: number | null
	holders_change_24h_pct: number | null
	change_24h_pct: number | null
	change_7d_pct: number | null
	volume_24h_usd: number | null
	volume_buy_24h_usd: number | null
	volume_sell_24h_usd: number | null
	txns_24h: number | null
	txns_buy_24h: number | null
	txns_sell_24h: number | null
	liquidity_usd: number | null
	pools: AssetStatsPool[]
}

export default function useAssetStats(assetId: string | null): {
	stats: AssetStats | undefined
	isLoading: boolean
} {
	const { data, isLoading } = useSwr<AssetStats>(
		assetId ? `${API_URL}/alkane/asset/${assetId}/stats` : null,
		strictFetcher,
		{ refreshInterval: 60_000, revalidateOnFocus: false, keepPreviousData: false }
	)
	// keepPreviousData deliberately OFF: asset A's holder count under asset
	// B's name while B loads would be a lie with a badge on it.
	return { stats: data, isLoading }
}
